export enum ProofOfPaymentType {
  PAYMENT_CONFIRMATION = 'PAYMENT_CONFIRMATION',
  COMPROVANTE_OPERACAO = 'COMPROVANTE_OPERACAO',
  NONE = '',
}
